import React from 'react';
import { XMarkIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

interface AddProviderModalProps {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}

const AddProviderModal: React.FC<AddProviderModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 bg-[var(--brand-overlay-backdrop)] backdrop-blur-sm" onClick={onClose} />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div
          className="bg-[var(--brand-surface-card)] border border-[var(--brand-border)] rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--brand-border)]">
            <div>
              <h2 className="text-lg font-semibold text-[var(--brand-text-primary)]">Add AI Provider</h2>
              <p className="text-xs text-[var(--brand-text-tertiary)] mt-0.5">
                Provider setup is governed by EdgeLex runtime policy.
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-1.5 rounded-lg hover:bg-[var(--brand-surface-secondary)] text-[var(--brand-text-tertiary)]"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>

          <div className="px-6 py-5">
            <div className="rounded-xl border border-emerald-200 dark:border-emerald-800 bg-emerald-50/70 dark:bg-emerald-900/15 p-4 flex items-start gap-3">
              <ShieldCheckIcon className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mt-0.5 flex-shrink-0" />
              <div className="text-sm text-emerald-900 dark:text-emerald-100">
                <div className="font-semibold">Legacy provider setup has been removed.</div>
                <p className="mt-1 text-emerald-800 dark:text-emerald-200">
                  Active model access is controlled through the EdgeLex governance registry and LangGraph runtime policy.
                  New provider onboarding should be added to that registry directly.
                </p>
              </div>
            </div>
          </div>

          <div className="px-6 py-4 border-t border-[var(--brand-border)] flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-[var(--brand-accent-primary)] text-white text-sm font-medium hover:opacity-90"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProviderModal;
